import { useEffect, useState } from 'react';
import { ShopListItem } from '~/components/ui/ShopListItem';
import { rage } from '~/rage';
import { BarberShopItemConfig, BarberShopSection, WalletType } from '~/shared';

interface IListItemWithName extends BarberShopItemConfig {
	name: string;
}

const ListTabItem = ({
	item,
	index,
	activeCategory,
	activeListIndex,
	handleSelect,
}: {
	item: IListItemWithName;
	index: number;
	activeCategory: BarberShopSection;
	activeListIndex: number | null;
	handleSelect: (index: number) => void;
}) => {
	const seenTrackerKey = `${activeCategory}.${item.overlaySection}.${item.index}`;
	const [isUnseen, setIsUnseen] = useState(
		rage.barberShop.isUnseen(seenTrackerKey),
	);

	useEffect(() => {
		if (index === activeListIndex) {
			const seenTrackerKey = `${activeCategory}.${item.overlaySection}.${item.index}`;
			rage.barberShop.markSeen(seenTrackerKey);
			setIsUnseen(false);
		}
	}, [index, activeListIndex, activeCategory, item.overlaySection, item.index]);

	return (
		<ShopListItem
			title={item.name}
			price={item.price ?? 0}
			walletType={WalletType.Cash}
			id={`hair-${item.overlaySection}-${item.index}-${index}`}
			handleClick={() => handleSelect(index)}
			active={index === activeListIndex}
			installed={false}
			isNew={isUnseen}
			key={index}
		/>
	);
};

export { ListTabItem };
